import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchAuditLogExports } from 'actions/utils';
import { CSVLink } from 'react-csv';
import { Button } from '@blueprintjs/core';
import isEqual from 'lodash/isEqual';
import moment from 'moment';

const headers = [
  { label: 'Assessment ID', key: 'vendorRequestID' },
  {
    label: 'User ID',
    key: 'userID',
  },
  {
    label: 'User Name',
    key: 'userName',
  },
  { label: 'Date & Time', key: 'date' },
  { label: 'Action', key: 'action' },
  { label: 'Details', key: 'modifyMessage' },
];

class Export extends Component {
  state = { data: [] };

  componentDidMount() {
    this.props.fetchAuditLogExports({
      ...this.props.exportParams,
      start: 0,
      limit: -1,
      from: 'exports',
    });
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.exportParams, this.props.exportParams)) {
      this.props.fetchAuditLogExports({
        ...this.props.exportParams,
        start: 0,
        limit: -1,
      });
    }
  }
  render() {
    const { isFetching } = this.props;
    return (
      <React.Fragment>
        {!isFetching && (
          <CSVLink
            data={this.props.exports}
            headers={headers}
            asyncOnClick={true}
            filename={`audit-log-${moment().format('DD-MM-YYYY')}.csv`}
          >
            <Button
              minimal={true}
              icon="export"
              intent="primary"
              text="EXPORT"
            />
          </CSVLink>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  exports: state.utils.auditLogExports,
  isFetching: state.utils.isFetchingAuditLog,
});

Export = connect(
  mapStateToProps,
  { fetchAuditLogExports }
)(Export);

export default Export;
